import { NextActionCell } from "components/OverviewPages/siteTableRenderers";
import {
  ColorMappedCell,
  DateCell
} from "components/SharedTable/tableRenderers";
import { SiteOverview } from "interfaces/site-overview";
import { CellProps, Column } from "react-table";

export const getSiteTableColumns = (
  hasFeature: (feature: string) => boolean
): Column<SiteOverview>[] => {
  const baseColumns: Column<SiteOverview>[] = [
    {
      Header: "Machine",
      id: "name",
      sortType: "siteOverviewMachineSortType",
      accessor: data => data.name
    },
    {
      Header: "Cases Open",
      id: "open_case_count",
      accessor: data => data.open_case_count
    },
    {
      Header: "Machine Status",
      id: "machine_status",
      sortType: "siteOverviewStatusSortType",
      accessor: data => data.machine_status,
      Cell: (cellProps: CellProps<SiteOverview>) => {
        return ColorMappedCell({ value: cellProps.value });
      }
    },
    {
      Header: "Next Action",
      id: "next_action",
      sortType: "stringSortType",
      accessor: data => data.next_action,
      Cell: (cellProps: CellProps<SiteOverview>) =>
        NextActionCell({ value: cellProps.value })
    },
    {
      Header: "Action Due Date",
      id: "next_action_due_date",
      accessor: data => data.next_action_due_date,
      sortType: "dateTimeSortType",
      Cell: (cellProps: CellProps<SiteOverview>) =>
        DateCell({ value: cellProps.value })
    }
  ];

  if (hasFeature("alerts")) {
    // Insert the "Active Alert" column as the third column
    baseColumns.splice(2, 0, {
      Header: "Active Alert",
      id: "active_alerts",
      accessor: data => data.active_alerts
    });
  }

  return baseColumns;
};
